export const CUSTOM_MATCH_BY_POPULAR: string = 'custom-matches-aggregator-groups-overview/:disciplineId/all/all/all/all/POPULAR/BOTH';